import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import utils, { comnEnvs, comnUtils } from "@/comn/utils";
import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useStore, useToast, useResource, useModal, usePage } from "@/comn/hooks";
import {
    APIS,
    SF_NOTI_HIST_SRCH,
    SG_NOTI_HIST_LIST,
    URLS,
    SETTINGS_MAP,
} from "@/tra/tancis/ptli/ptl/ntcmgmt/services/PtliNtcMgmtService";

/*
 * Notice List
 * !== 공지•통지 목록 ==!
 */
export const PTLI0801001Q = (): JSX.Element => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0001", "auth_ptli0015", "auth_ptlianyADM"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal();
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "PTL0022" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Notifice List Search !== 알림 목록 검색 ==!
        notiHistListSrch: useForm({
            defaultSchema: SF_NOTI_HIST_SRCH,
            defaultValues: {
                ...pgeStore?.form,
                sendStrtDt: comnUtils.getDate({ m: -1 }),
                sendEndDt: comnUtils.getDate(),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Notifice List !== 알림 목록 ==!
        notiHistList: useGrid({
            defaultSchema: SG_NOTI_HIST_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        //Check Notifice History List !==  알림 이력 목록 조회 ==!
        getNotiHistList: useFetch({
            api: (page = grid.notiHistList.page) =>
                APIS.getNotiHistList(form.notiHistListSrch.getValues(), page, grid.notiHistList.size),
            enabled: comnUtils.isEmpty(form.notiHistListSrch.errors),
            key: [grid.notiHistList.page, grid.notiHistList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.notiHistListSrch.getValues(),
                    page: grid.notiHistList.page,
                    size: grid.notiHistList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
            showToast: true,
        }),
    };
    const render = {
        cell: {
            notiNm: (props: any) => {
                const { rowValues, value } = props;
                return <Link to={`/ptli/ptl/ntcmgmt/ptli0801002s/${rowValues.notiSendUuid}`}>{value}</Link>;
            },
            rcpnCfrmYn: (props: any) => {
                const { rowValues, value } = props;

                return value === "Y" ? "Yes" : "No";
            },
            notiTpValue: (props: any) => {
                const { rowValues, value } = props;

                return SETTINGS_MAP[Number(value)];
            },
        },
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Click Search Button !== 검색버튼 ==!
        onSrchBtnClick: (page: number = 0) => {
            grid.notiHistList.setPage(page);
            fetch.getNotiHistList.fetch(page);
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        handler.onSrchBtnClick(pgeStore?.page);
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.notiHistListSrch.schema.frstRgsrDtmRnge} />
                            <Group.Control {...form.notiHistListSrch.schema.notiNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.notiHistListSrch.schema.usrNm} />
                            <Group.Control {...form.notiHistListSrch.schema.notiSendStatCd} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => form.notiHistListSrch.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role={"search"}
                                onClick={() => {
                                    handler.onSrchBtnClick();
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.notiHistList.grid}
                            data={fetch.getNotiHistList.data?.ntcMgmtList}
                            render={render}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
